import { bundleInfo, versionLabel, versionTitle } from "../lib/appVersion";
import { WHATS_NEW_OPEN_EVENT } from "../hooks/useWhatsNew";
import { parseRelease } from "../lib/whatsNew";

// The version this tab runs, in small print (lot 29, V2). The tooltip adds the commit and the build date. On a real published version a
// click reopens the « Nouveautés » panel (lot S5); a local build (« dev ») stays plain text.
export default function VersionBadge({ className = "", testid = "app-version" }) {
  const info = bundleInfo();
  const base = `text-2xs text-white/50 ${className}`;
  if (parseRelease(info.version) === null) {
    return <span className={base} title={versionTitle(info)} data-testid={testid}>Version {versionLabel(info.version)}</span>;
  }
  return (
    <button
      type="button"
      className={`${base} cursor-pointer text-left hover:underline focus-visible:underline focus:outline-none`}
      title={`${versionTitle(info)} · voir les nouveautés`}
      data-testid={testid}
      onClick={() => window.dispatchEvent(new Event(WHATS_NEW_OPEN_EVENT))}
    >
      Version {versionLabel(info.version)}
    </button>
  );
}
